import { Box, styled } from '@mui/material';
import WorldMapChart from 'components/charts/WorldMapChart';
import CustomTooltip from 'components/shared/tooltip';

const Tooltip = styled('div')({
  padding: '0.5rem',
  border: '1px solid silver',
  color: '#222',
  backgroundColor: '#fff',
  borderRadius: '5px',
  boxShadow: '0px 0px 5px 0px #a6a6a6',
  whiteSpace: 'nowrap',
  span: {
    fontWeight: 'bold',
  },
});

const CoverageMap = ({ item }) => {
  return (
    <>
      <WorldMapChart
        defaultCountryColor="#D8D8D8"
        defaultCountryHoverColor="#C8C8C8"
        hoverBorderColor="#FFFFFF"
        hoverColor="#151F57"
        selectedFillColor="#9dcce5"
        width={670}
        height={290}
        projectionConfig={{
          scale: 115,
        }}
        preserveAspectRatio="xMidYMid meet"
        data={item}
        popupTemplate={(geo, data) => {
          const title = geo.properties.name;
          return (
            <CustomTooltip sx={{ whiteSpace: 'nowrap' }} variant={'white'} open={true} title={title}></CustomTooltip>
          );
        }}
      />
    </>
  );
};

export default CoverageMap;
